import { useMemo, useState } from "react";
import { ArrowUpDown, Search } from "lucide-react";
import { Input } from "./ui/input";
import { fmtNum, slug } from "../lib/format";
import { fmtClock, fmtDur } from "../lib/pickerSheet";

const COLS = [
  ["id", "Picker", (u) => u.id],
  ["mainShift", "Main shift", (u) => u.mainShift],
  ["daysWorked", "Days", (u) => u.daysWorked],
  ["avgPicksWk", "Avg picks / wk", (u) => fmtNum(Math.round(u.avgPicksWk))],
  ["avgHoursWk", "Avg hours / wk", (u) => u.avgHoursWk.toFixed(1)],
  ["pph", "Picks / hr worked", (u) => fmtNum(u.pph)],
  ["avgStart", "Avg start", (u) => fmtClock(u.avgStart)],
  ["avgFinish", "Avg finish", (u) => fmtClock(u.avgFinish)],
  ["avgLostDay", "Avg lost / day", (u) => fmtDur(u.avgLostDay)],
  ["gapCount", "Large gaps", (u) => fmtNum(u.gapCount)],
  ["otDays", "OT days", (u) => (u.otDays ? `${u.otDays} · ${fmtDur(u.ot)}` : "—")],
];

export const TeamSheetTable = ({ users, onOpen }) => {
  const [q, setQ] = useState("");
  const [sort, setSort] = useState(["avgPicksWk", -1]);
  const rows = useMemo(() => {
    const f = q ? users.filter((u) => u.id.toLowerCase().includes(q.toLowerCase())) : users;
    const [k, d] = sort;
    return [...f].sort((a, b) => (a[k] > b[k] ? d : a[k] < b[k] ? -d : 0));
  }, [users, q, sort]);
  return (
    <div className="panel" data-testid="team-sheet-table">
      <div className="flex flex-wrap items-center justify-between gap-3 p-5 border-b border-slate-800">
        <div>
          <h3 className="font-display text-lg font-semibold text-slate-100">Picker sheet <span className="font-mono text-sm text-slate-500">({rows.length})</span></h3>
          <p className="text-xs text-slate-500">Click a picker for their weekly sheet</p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          <Input data-testid="sheet-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search pickers…" className="pl-9 bg-[#0B0F19] border-slate-700 text-slate-100" />
        </div>
      </div>
      <div className="overflow-x-auto max-h-[640px]">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-[#111827] z-10"><tr className="border-b border-slate-800">
            {COLS.map(([k, l]) => (
              <th key={k} className="text-left px-4 py-3 whitespace-nowrap">
                <button data-testid={`sheet-sort-${k}`} onClick={() => setSort([k, sort[0] === k ? -sort[1] : -1])} className={`inline-flex items-center gap-1 font-mono text-xs uppercase tracking-wider ${sort[0] === k ? "text-ep-soft" : "text-slate-500 hover:text-slate-300"}`}>{l}<ArrowUpDown className="h-3 w-3" /></button>
              </th>
            ))}
          </tr></thead>
          <tbody>{rows.map((u) => (
            <tr key={u.id} data-testid={`sheet-row-${slug(u.id)}`} onClick={() => onOpen(u.id)} className="border-b border-slate-800/60 last:border-0 hover:bg-slate-800/40 cursor-pointer transition-colors duration-150">
              {COLS.map(([k, , f], i) => (
                <td key={k} className={`px-4 py-3 whitespace-nowrap ${i === 0 ? "text-slate-100 font-medium" : "font-mono text-slate-300"} ${k === "avgLostDay" ? "text-rose-300" : ""}`}>{f(u)}</td>
              ))}
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
};
